{
  "tickets.actions.assign": "分配",
  "tickets.actions.assignToMe": "分配给我",
  "tickets.actions.claimedToast": "工单已分配给你",
  "tickets.actions.claimError": "认领工单失败，请稍后重试。",
  "tickets.actions.cancel": "取消",
  "tickets.actions.close": "关闭",
  "tickets.actions.changePriority": "更改优先级",
  "tickets.actions.clearFilters": "清除筛选",
  "tickets.actions.create": "创建工单",
  "tickets.actions.download": "下载",
  "tickets.actions.export": "导出",
  "tickets.actions.exportUnavailable": "导出尚未接入后端",
  "tickets.actions.leave": "退出参与",
  "tickets.actions.refresh": "刷新",
  "tickets.actions.reopen": "重新打开",
  "tickets.actions.resolve": "标记为已解决",
  "tickets.actions.resume": "恢复处理",
  "tickets.actions.updating": "更新中",
  "tickets.actions.view": "查看工单",
  "tickets.actions.wait": "转为等待",
  "tickets.activity.collapseEvents": "收起",
  "tickets.activity.emptyDescription": "状态流转与内部消息都会记录在这里。",
  "tickets.activity.emptyTitle": "还没有活动记录",
  "tickets.activity.expandEvents": "等 {count} 条操作记录",
  "tickets.activity.failed": "发送失败",
  "tickets.activity.internalMessage": "内部消息",
  "tickets.activity.scrollToBottom": "滚动到底部",
  "tickets.activity.scrollToBottomAria": "滚动到活动底部",
  "tickets.activity.sending": "发送中",
  "tickets.activity.sendingInternalMessage": "内部消息发送中",
  "tickets.activity.sent": "发送成功",
  "tickets.activity.systemAuthor": "系统",
  "tickets.activity.timelineAria": "内部活动时间线",
  "tickets.ai.alternativeReasonFallback": "语义接近，可作为备选",
  "tickets.ai.applied": "已采用 AI 建议 · {confidence}",
  "tickets.ai.appliedToast": "已采用 AI 建议：{category}",
  "tickets.ai.apply": "采用",
  "tickets.ai.applyCategoryAria": "采用分类 {category}",
  "tickets.ai.applyError": "AI 建议采用失败，已恢复原分类。",
  "tickets.ai.applying": "正在采用建议…",
  "tickets.ai.applyingCategory": "AI 分类采用中",
  "tickets.ai.applyingCategoryAria": "正在采用分类 {category}",
  "tickets.ai.applyingShort": "采用中",
  "tickets.ai.bestMatch": "最佳匹配",
  "tickets.ai.bestReasonFallback": "与工单核心诉求的语义匹配度较高",
  "tickets.ai.categoryFallback": "分类 {id}",
  "tickets.ai.classification": "AI 智能分类",
  "tickets.ai.currentReasonable": "当前分类合理 · {confidence}",
  "tickets.ai.generate": "生成建议",
  "tickets.ai.generateError": "AI 建议生成失败，请稍后重试。",
  "tickets.ai.generatedToast": "AI 分类建议已生成",
  "tickets.ai.generating": "AI 分类生成中",
  "tickets.ai.generatingAria": "正在生成 AI 分类建议",
  "tickets.ai.noMatch": "AI 暂未找到合适的分类",
  "tickets.ai.otherSuggestions": "其他 {count} 条建议",
  "tickets.ai.progress.analyzing": "正在分析核心诉求…",
  "tickets.ai.progress.evaluating": "正在评估建议置信度…",
  "tickets.ai.progress.matching": "正在匹配分类体系…",
  "tickets.ai.progress.reading": "正在读取工单信息…",
  "tickets.ai.regenerate": "重新生成",
  "tickets.ai.review": "AI 复核",
  "tickets.ai.reviewAria": "使用 AI 复核当前分类",
  "tickets.assignment.assignedTo": "已分配给 {assignee}",
  "tickets.assignment.assignedToTeam": "已分配至 {team}",
  "tickets.assignment.assigneeFailed": "跟进人分配失败，请稍后重试。",
  "tickets.assignment.dialogDescription": "明确这张工单由哪个客服组负责，也可以指定一位跟进人。",
  "tickets.assignment.dialogTitle": "分配工单",
  "tickets.assignment.failed": "分配失败，请稍后重试。",
  "tickets.assignment.loadingMembers": "正在读取组内成员",
  "tickets.assignment.loadingTeams": "正在读取客服组",
  "tickets.assignment.noAssignee": "暂不指定跟进人",
  "tickets.assignment.noEligibleMembers": "该组暂无可分配成员，仍可只分配客服组。",
  "tickets.assignment.noEligibleTeams": "当前项目暂无可分配的在用客服组。",
  "tickets.assignment.noTeam": "未分配客服组",
  "tickets.assignment.none": "暂未分配跟进组与跟进人",
  "tickets.assignment.openDialogAria": "分配客服组与跟进人",
  "tickets.assignment.optionsError": "分配候选加载失败，请关闭弹窗后重试。",
  "tickets.assignment.partialError": "客服组已更新，但跟进人分配失败：{message}",
  "tickets.assignment.pending": "待分配",
  "tickets.assignment.pendingAssignee": "待分配跟进人",
  "tickets.assignment.save": "保存分配",
  "tickets.assignment.saving": "正在保存分配",
  "tickets.assignment.selectAssignee": "选择跟进人",
  "tickets.assignment.selectTeam": "选择客服组",
  "tickets.assignment.selectTeamFirst": "请先选择客服组",
  "tickets.assignment.team": "客服组",
  "tickets.assignment.teamFallback": "客服组",
  "tickets.assignment.unassigned": "未分配",
  "tickets.assignment.unknownMember": "未知成员",
  "tickets.assignment.unknownTeam": "未知客服组",
  "tickets.assignment.willUnassign": "保存后将同时取消 {assignee} 的跟进分配。",
  "tickets.attachment.downloadError": "没能下载这个附件，请稍后重试。",
  "tickets.attachment.downloading": "正在下载附件",
  "tickets.attachment.emptyDescription": "在下方的编辑器里添加文件，随消息一起发出后会出现在这里。",
  "tickets.attachment.emptyFile": "（空文件）",
  "tickets.attachment.emptyTitle": "还没有附件",
  "tickets.attachment.loading": "正在加载附件…",
  "tickets.attachment.messageListAria": "消息附件",
  "tickets.attachment.noRemoteSource": "这个附件没有服务端来源。",
  "tickets.attachment.openAria": "打开附件 {name}",
  "tickets.attachment.previewAria": "预览附件 {name}",
  "tickets.attachment.previewError": "没能读取这个附件，请稍后重试或直接下载。",
  "tickets.attachment.previewTitle": "附件预览",
  "tickets.attachment.previewTruncated": "……预览仅展示前 200 KB",
  "tickets.attachment.previewUnsupported": "这类文件不支持就地预览，下载后查看。",
  "tickets.attachment.reading": "正在读取附件…",
  "tickets.attachment.ticketListAria": "工单附件",
  "tickets.attachment.type.archive": "压缩包",
  "tickets.attachment.type.audio": "音频",
  "tickets.attachment.type.document": "文档",
  "tickets.attachment.type.file": "文件",
  "tickets.attachment.type.image": "图片",
  "tickets.attachment.type.pdf": "PDF",
  "tickets.attachment.type.presentation": "演示文稿",
  "tickets.attachment.type.spreadsheet": "表格",
  "tickets.attachment.type.text": "文本文件",
  "tickets.attachment.type.video": "视频",
  "tickets.bulk.ariaLabel": "批量操作",
  "tickets.bulk.clearSelection": "取消选择",
  "tickets.bulk.selectedCount": "已选择 {count} 个工单",
  "tickets.bulk.selectionStatus": "选择状态",
  "tickets.bulk.unavailable": "{action}尚未接入后端",
  "tickets.category.uncategorized": "未分类",
  "tickets.channel.api": "API",
  "tickets.channel.phone": "电话",
  "tickets.channel.unknown": "—",
  "tickets.channel.web": "网页",
  "tickets.composer.addAttachmentAria": "添加附件",
  "tickets.composer.attachmentCount": "附件 {count}/{max}",
  "tickets.composer.attachmentLimit": "最多添加 {count} 个附件",
  "tickets.composer.attachmentsUploading": "附件上传中…",
  "tickets.composer.cancelledHint": "工单已取消，无法添加消息。",
  "tickets.composer.closedHint": "工单已关闭，无法添加消息。",
  "tickets.composer.contentAria": "内部消息内容",
  "tickets.composer.dropFiles": "松开以添加文件",
  "tickets.composer.duplicatesIgnored": "已忽略 {count} 个重复文件",
  "tickets.composer.failedUploadHint": "有附件上传失败，请重试或移除",
  "tickets.composer.fileUploading": "{name} 上传中",
  "tickets.composer.longPasteConverted": "粘贴内容较长，已转换为文本附件",
  "tickets.composer.mention.currentTeam": "{team} · 当前客服组",
  "tickets.composer.mention.duplicateName": "同名",
  "tickets.composer.mention.empty": "没有匹配的人员",
  "tickets.composer.mention.error": "没能加载候选人员，请稍后重试。",
  "tickets.composer.mention.hasMore": "还有更多，继续输入以缩小范围",
  "tickets.composer.mention.identifier": "成员 ID 尾号 {identifier}",
  "tickets.composer.mention.loading": "正在加载…",
  "tickets.composer.mention.loadingCandidates": "正在加载候选人员",
  "tickets.composer.mention.searching": "正在搜索相关人员",
  "tickets.composer.mention.title": "提及相关人员",
  "tickets.composer.mention.ungrouped": "未编组成员",
  "tickets.composer.mentionCollaboratorAria": "提及协作者",
  "tickets.composer.oversizedFiles": "{files} 超过 {maxSize}",
  "tickets.composer.pasteHint": "可直接粘贴图片、PDF、文本、Office 文件",
  "tickets.composer.pastedTextFileName": "粘贴文本.txt",
  "tickets.composer.pendingAttachmentsAria": "待发送附件",
  "tickets.composer.placeholder": "记录排查进展，输入 @ 可提及协作者，也可以直接粘贴文件…",
  "tickets.composer.removeAttachmentAria": "移除附件 {name}",
  "tickets.composer.resolveFailedUploadsTitle": "先重试或移除上传失败的附件",
  "tickets.composer.retryUploadAria": "重新上传 {name}",
  "tickets.composer.submitAria": "添加内部消息",
  "tickets.composer.submitShortcut": "⌘ + Enter 添加",
  "tickets.composer.supportedFilesTitle": "支持图片、PDF、文本、Office、压缩包与音视频，单个不超过 {maxSize}",
  "tickets.composer.unsupportedFiles": "{files} 的文件类型不受支持",
  "tickets.composer.uploadFailed": "上传失败",
  "tickets.composer.uploadFailureAria": "上传失败：{reason}",
  "tickets.composer.uploadInProgressTitle": "附件还在上传",
  "tickets.composer.uploading": "上传中",
  "tickets.customer.empty": "未记录客户信息",
  "tickets.customer.noContact": "未记录联系方式",
  "tickets.customer.profile": "客户档案",
  "tickets.customer.snapshot": "提单快照",
  "tickets.customer.unnamed": "未命名客户",
  "tickets.customer.viewDetails": "查看客户",
  "tickets.detail.archive": "归档工单",
  "tickets.detail.archiveUnavailable": "归档工单尚未接入后端",
  "tickets.detail.bodyLabel": "工单内容",
  "tickets.detail.collapseBody": "收起内容",
  "tickets.detail.copyLink": "复制工单链接",
  "tickets.detail.createdAt": "创建于 {time}",
  "tickets.detail.expandBody": "展开完整内容",
  "tickets.detail.follow": "关注工单",
  "tickets.detail.followUnavailable": "关注工单尚未接入后端",
  "tickets.detail.from": "来自",
  "tickets.detail.linkCopied": "工单链接已复制",
  "tickets.detail.loading": "正在加载工单…",
  "tickets.detail.loadingDetail": "正在加载工单详情…",
  "tickets.detail.moreActionsAria": "更多工单操作",
  "tickets.detail.noBody": "此工单没有填写正文",
  "tickets.detail.notLoaded": "工单详情尚未加载完成。",
  "tickets.detail.resolvedAria": "工单已解决",
  "tickets.detail.resolvedToast": "工单已标记为已解决",
  "tickets.resolution.dialogTitle": "解决工单",
  "tickets.resolution.dialogDescription": "请记录工单 #{number} 的处理结果和已向用户反馈的方式。",
  "tickets.resolution.resultLabel": "解决结果",
  "tickets.resolution.resultPlaceholder": "填写处理过程与最终结果，最多 4000 字",
  "tickets.resolution.feedbackMethodLabel": "反馈方式",
  "tickets.resolution.feedbackSummary": "已通过{method}反馈",
  "tickets.resolution.method.phone": "电话",
  "tickets.resolution.method.sms": "短信",
  "tickets.resolution.method.email": "邮件",
  "tickets.resolution.method.other": "其他",
  "tickets.resolution.otherLabel": "具体反馈方式",
  "tickets.resolution.otherPlaceholder": "例如：当面反馈、微信等",
  "tickets.resolution.recordOnlyHint": "请记录已向用户反馈的方式，此操作不会发送短信或邮件。",
  "tickets.resolution.submit": "保存并标记已解决",
  "tickets.resolution.submitting": "正在解决…",
  "tickets.resolution.concurrencyError": "工单已发生变化，填写内容已保留。请核对当前工单状态后重试。",
  "tickets.resolution.statusChangedError": "工单已不是处理中状态，暂时无法解决。填写内容已保留，请核对工单状态。",
  "tickets.resolution.validation.resultRequired": "请填写解决结果。",
  "tickets.resolution.validation.resultTooLong": "解决结果不能超过 4000 字。",
  "tickets.resolution.validation.methodRequired": "请选择反馈方式。",
  "tickets.resolution.validation.otherRequired": "请填写具体反馈方式。",
  "tickets.resolution.validation.otherTooLong": "具体反馈方式不能超过 100 字。",
  "tickets.resolution.activityTitle": "解决记录",
  "tickets.resolution.expandResult": "展开完整结果",
  "tickets.resolution.collapseResult": "收起结果",
  "tickets.resolution.otherDisplay": "其他（{method}）",
  "tickets.detail.returnToList": "返回列表",
  "tickets.detail.statusUpdateError": "状态更新失败，请重试。",
  "tickets.detail.statusUpdating": "状态更新中",
  "tickets.detail.tabs.activities": "活动",
  "tickets.detail.tabs.attachments": "附件",
  "tickets.detail.tabs.linkedEntities": "关联",
  "tickets.detail.tabs.properties": "属性",
  "tickets.detail.via": "渠道",
  "tickets.fields.actions": "操作",
  "tickets.fields.assignee": "跟进人",
  "tickets.fields.assignment": "分配",
  "tickets.fields.category": "分类",
  "tickets.fields.channel": "渠道",
  "tickets.fields.closedAt": "关闭时间",
  "tickets.fields.creationTime": "创建时间",
  "tickets.fields.customer": "客户",
  "tickets.fields.extendedInfo": "扩展信息",
  "tickets.fields.firstResponseAt": "首次响应",
  "tickets.fields.lastUpdated": "最近更新",
  "tickets.fields.number": "工单号",
  "tickets.fields.participants": "协作者",
  "tickets.fields.priority": "优先级",
  "tickets.fields.project": "项目",
  "tickets.fields.requesterSnapshot": "联系方式",
  "tickets.fields.resolvedAt": "解决时间",
  "tickets.fields.status": "状态",
  "tickets.fields.subject": "主题",
  "tickets.fields.ticketExtendedInfo": "工单扩展信息",
  "tickets.linked.copiedToast": "业务标识已复制",
  "tickets.linked.copyIdAria": "复制{entityType}标识",
  "tickets.linked.emptyDescription": "业务系统随工单提交的订单、账户等关联对象会显示在这里。",
  "tickets.linked.emptyTitle": "暂无关联业务",
  "tickets.linked.linkedAt": "关联于 {time}",
  "tickets.linked.listAria": "工单关联业务",
  "tickets.linked.loading": "正在加载关联业务…",
  "tickets.linked.viewExtendedData": "查看扩展数据",
  "tickets.linked.downloadFailed": "关联文件下载失败",
  "tickets.callRecord.type": "通话记录",
  "tickets.callRecord.time": "通话时间",
  "tickets.callRecord.duration": "通话时长",
  "tickets.callRecord.agent": "坐席",
  "tickets.recording.title": "通话录音",
  "tickets.recording.play": "播放录音",
  "tickets.recording.pause": "暂停录音",
  "tickets.recording.seek": "播放进度",
  "tickets.recording.speed": "播放速度",
  "tickets.recording.download": "下载录音",
  "tickets.recording.loading": "正在读取录音…",
  "tickets.recording.unavailable": "暂无录音",
  "tickets.recording.loadFailed": "录音读取失败，请点击播放或下载重试。",
  "tickets.recording.playFailed": "暂时无法播放，请再次点击播放；若浏览器不支持此格式，可下载后收听。",
  "tickets.linked.sourceRecordMissing": "外部数据源未找到这条记录",
  "tickets.linked.sourceUnavailable": "暂时无法读取外部数据源，已保留关联标识。",
  "tickets.list.emptyDescription": "新建工单后会出现在这里。",
  "tickets.list.emptyFilteredDescription": "调整搜索关键词或筛选条件后再试。",
  "tickets.list.emptyFilteredTitle": "没有符合条件的工单",
  "tickets.list.emptyTitle": "还没有工单",
  "tickets.list.lastUpdated": "最近更新 {time}",
  "tickets.list.loading": "正在加载工单…",
  "tickets.list.loadingList": "正在加载工单列表…",
  "tickets.list.messageCount": "{count} 条消息",
  "tickets.list.refreshing": "正在刷新工单",
  "tickets.list.searchAria": "搜索工单",
  "tickets.list.searchPlaceholder": "搜索工单号或主题…",
  "tickets.list.selectAll": "选择当前列表中的全部工单",
  "tickets.list.selectTicket": "选择 {number}",
  "tickets.list.ticketActions": "{number} 操作",
  "tickets.new.createdToast": "工单已创建并进入待分配队列",
  "tickets.new.description": "记录客户问题并分配到合适的支持队列。",
  "tickets.new.issueDescription": "问题描述",
  "tickets.new.issuePlaceholder": "补充客户背景、现象和已尝试的处理方式…",
  "tickets.new.subjectPlaceholder": "简要描述客户遇到的问题",
  "tickets.new.submit": "创建工单",
  "tickets.new.title": "新建工单",
  "tickets.new.trigger": "新建工单",
  "tickets.new.validation.issueRequired": "请填写问题描述。",
  "tickets.new.validation.subjectRequired": "请填写工单主题。",
  "tickets.participants.countAria": "协作者，共 {count} 人",
  "tickets.participants.empty": "暂无协作者",
  "tickets.participants.hiddenCountAria": "另有 {count} 位协作者",
  "tickets.priority.ariaLabel": "{priority}优先级",
  "tickets.priority.high": "高",
  "tickets.priority.low": "低",
  "tickets.priority.medium": "中",
  "tickets.priority.normal": "普通",
  "tickets.new.automaticPriority": "自动（按分类）",
  "tickets.priority.unknown": "未知",
  "tickets.priority.urgent": "紧急",
  "tickets.project.unspecified": "未指定项目",
  "tickets.properties.state": "工单状态",
  "tickets.properties.categoryRemoved": "已移除工单分类",
  "tickets.properties.categoryUpdateError": "分类更新失败，已恢复原分类。",
  "tickets.properties.categoryUpdated": "分类已更新为{category}",
  "tickets.properties.categoryUpdating": "分类修改中",
  "tickets.properties.followUp": "客服组与跟进人",
  "tickets.properties.priorityUpdateError": "优先级更新失败，已恢复原优先级。",
  "tickets.properties.priorityUpdated": "优先级已更新为{priority}",
  "tickets.properties.priorityUpdating": "优先级修改中",
  "tickets.properties.statusUpdateError": "状态更新失败，已恢复原状态。",
  "tickets.properties.statusUpdated": "状态已更新为{status}",
  "tickets.properties.statusUpdating": "状态修改中",
  "tickets.status.cancelled": "已取消",
  "tickets.status.closed": "已关闭",
  "tickets.status.new": "新建",
  "tickets.status.open": "处理中",
  "tickets.status.pending": "挂起",
  "tickets.status.resolved": "已解决",
  "tickets.status.unknown": "未知",
  "tickets.tabs.active": "处理中",
  "tickets.tabs.all": "全部",
  "tickets.tabs.pending": "等待中",
  "tickets.tabs.resolved": "已解决",
  "tickets.tabs.closed": "已关闭",
  "tickets.tags.unknown": "未知标签",
  "tickets.time.justNow": "刚刚",
  "tickets.timeline.assigned.actor": "{actor} 将工单指派给 {to}",
  "tickets.timeline.assigned.system": "工单已指派给 {to}",
  "tickets.timeline.attachmentAdded.actor": "{actor} 添加了附件",
  "tickets.timeline.attachmentAdded.system": "已添加附件",
  "tickets.timeline.categoryChanged.actor": "{actor} 将分类改为 {to}",
  "tickets.timeline.categoryChanged.system": "分类已改为 {to}",
  "tickets.timeline.categoryCleared.actor": "{actor} 清空了分类",
  "tickets.timeline.categoryCleared.system": "分类已清空",
  "tickets.timeline.contentUpdated.actor": "{actor} 修改了工单内容",
  "tickets.timeline.contentUpdated.system": "工单内容已修改",
  "tickets.timeline.created.actor": "{actor} 创建了工单",
  "tickets.timeline.created.system": "工单已创建",
  "tickets.timeline.customerChanged.actor": "{actor} 将关联客户改为 {to}",
  "tickets.timeline.customerChanged.system": "关联客户已改为 {to}",
  "tickets.timeline.customerCleared.actor": "{actor} 解除了客户关联",
  "tickets.timeline.customerCleared.system": "客户关联已解除",
  "tickets.timeline.participantAdded.actor": "{actor} 添加协作者 {to}",
  "tickets.timeline.participantAdded.system": "已添加协作者 {to}",
  "tickets.timeline.participantRemoved.actor": "{actor} 移除协作者 {from}",
  "tickets.timeline.participantRemoved.system": "已移除协作者 {from}",
  "tickets.timeline.priorityChanged.actor": "{actor} 将优先级从 {from} 调整为 {to}",
  "tickets.timeline.priorityChanged.system": "优先级从 {from} 调整为 {to}",
  "tickets.timeline.routed.actor": "{actor} 将工单路由到 {to}",
  "tickets.timeline.routed.system": "工单已路由到 {to}",
  "tickets.timeline.statusChanged.actor": "{actor} 将状态从 {from} 改为 {to}",
  "tickets.timeline.statusChanged.system": "状态从 {from} 改为 {to}",
  "tickets.timeline.tagAdded.actor": "{actor} 添加标签 {to}",
  "tickets.timeline.tagAdded.system": "已添加标签 {to}",
  "tickets.timeline.tagRemoved.actor": "{actor} 移除标签 {from}",
  "tickets.timeline.tagRemoved.system": "已移除标签 {from}",
  "tickets.timeline.unassigned.actor": "{actor} 取消了指派",
  "tickets.timeline.unassigned.system": "指派已取消",
  "tickets.timeline.unassignedFrom.actor": "{actor} 取消了 {from} 的指派",
  "tickets.timeline.unassignedFrom.system": "{from} 的指派已取消",
  "tickets.timeline.unknown.actor": "{actor} 执行了 {action}",
  "tickets.timeline.unknown.system": "执行了 {action}",
  "tickets.timeline.unknownAction": "未知操作",
  "triage.queueCount": "共 {count} 条待分类",
  "triage.emptyTitle": "已经分完了",
  "triage.emptyDescription": "当前没有未分类的工单，新工单进来后会出现在这里。",
  "triage.panelEmptyTitle": "选一条工单开始分类",
  "triage.panelEmptyDescription": "在左侧队列里选中工单，这里会显示正文与分类建议。",
  "triage.noBody": "这条工单没有正文，可打开工单查看后续消息。",
  "triage.openTicket": "打开工单",
  "triage.pickCategory": "选择分类…",
  "triage.skip": "跳过",
  "triage.shortcutHint": "↑↓ 切换 · 回车采纳建议 · 1/2/3 选候选 · / 选分类",
  "triage.categorizedToast": "已分类为 {category}",
  "triage.aiAppliedToast": "已采用 AI 建议",
  "triage.bulkPickCategory": "批量设为分类…",
  "triage.bulkCategorizedToast": "已把 {count} 条工单分类为 {category}",
  "triage.bulkPartialToast": "{succeeded} 条已分类，{failed} 条失败",
  "triage.bulkCrossProject": "跨 {count} 个项目，只能选通用分类",
  "triage.bulkError": "批量分类失败，请稍后重试。",
  "triage.applyConfident": "一键采纳 {count} 条高置信建议",
  "triage.aiBatchAppliedToast": "已采纳 {count} 条 AI 建议",
  "triage.panelSheetTitle": "工单分类"
}
